import {
  DEMANDE_INTERVENTION_TYPE,
  DEMANDE_IMPRESSION_TYPE,
} from '@/configuration/logistique/suiviProduction/suiviProductionConfig';

export function mapDemandeLogistiqueToDemandeSuiviProduction(data, typesOT) {
  return {
    id: data.id,
    type: DEMANDE_INTERVENTION_TYPE,
    selected: false,
    title: typesOT.find(type => type.id === data.typeOtId)?.libelle ?? '',
    typeOt: typesOT.find(type => type.id === data.typeOtId),
    etat: data.etat,
    dateLimite: data.dateLimite,
    description: data.description,
    otTechniqueId: data.otTechniqueId,
    commercialId: data.ligneCommande?.commercialId,
    assistantId: data.ligneCommande?.assistantId,
    sujet: data.actionLogistique,
    annonceurs: data.ligneCommande?.allAnnonceurs.map(a => a.nomCommercial).join(', '),
    commandeId: data.ligneCommande?.devisCommandeId,
    ot: data.otTechnique,
    nbMessage: 0,
    tags: data.tags,
    ordre: data.ordreRealisation,
    ligneCommandeId: data.ligneCommandeId,
    theme: data.ligneCommande?.theme,
  };
}
export function mapDemandeImpressionToDemandeSuiviProduction(data, typesOT) {
  const typeOt = typesOT.find(type => type.id === data.typeOtId);
  return {
    id: data.id,
    campagneId: data.campagneId,
    type: DEMANDE_IMPRESSION_TYPE,
    selected: false,
    title: typeOt?.libelle ?? '',
    etat: data.etat,
    dateLimite: data.dateLimite,
    description: data.description,
    otTechniqueId: data.devisCommandes[0]?.id,
    commercialId: data.devisCommande.commercialId,
    assistantId: data.devisCommande.assistantId,
    sujet: data.commentaire,
    annonceurs: data.client.nomCommercial,
    commandeId: data.devisCommande.id,
    ot: data.devisCommandes[0],
    nbMessage: 0,
    tags: data.tags,
    urlLogoCampagne: data.urlLogoCampagne,
    theme: data.devisCommande.theme,
    color: typeOt?.couleur ?? '',
  };
}
